import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AuthState } from '@core/store/auth/auth.state';
import { SharedState } from '@core/store/shared/shared.state';
import { environment } from '@env/environment';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { NgxsModule } from '@ngxs/store';
import { NotificationState } from '@shared/components/notification-drawer/state/notification.state';
import { CookieService } from 'ngx-cookie-service';
import { HttpInterceptorService } from './services/auth/http-interceptor.service';
import { OrgService } from './services/org.service';
import { AppState } from './store/app/app.state';
import { EntityUpdatesState } from './store/entity-updates/entity-updates.state';
import { JobUpdatesState } from './store/job-updates/job-updates.state';
import { WorkflowState } from './store/workflow/workflow.state';
@NgModule({
  declarations: [],
  imports: [
    HttpClientModule,
    NgxsModule.forRoot(
      [AuthState, SharedState, NotificationState, WorkflowState, AppState, JobUpdatesState, EntityUpdatesState],
      {
        developmentMode: !environment.production,
      } as unknown
    ),
    ...(environment.production ? [] : [NgxsReduxDevtoolsPluginModule.forRoot()]),
    //TODO : Remove when doing refresh token
    NgxsStoragePluginModule.forRoot({
      key: 'auth',
      serialize: (obj: Record<string, unknown>) => {
        const { isLoading, ...rest } = obj;
        return JSON.stringify(rest);
      },
      deserialize: (str: string) => {
        const obj = JSON.parse(str);
        return { ...obj, isLoading: false };
      },
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    CookieService,
    OrgService,
  ],
  exports: [],
})
export class CoreModule {}
